"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    itemBubble: {
        correct: 'Correct',
        partially_correct: 'Partially correct',
        incorrect: 'Incorrect',
        not_scored: 'Not scored',
    },
};
